// Live cricket matches — fake but realistic to evoke a working sportsbook.
export const LIVE_MATCHES = [
  {
    id: "m1",
    league: "BPL T20",
    flag: "🇧🇩",
    teamA: { name: "Dhaka Capitals", short: "DHC", color: "#2563eb" },
    teamB: { name: "Comilla Victorians", short: "COV", color: "#dc2626" },
    score: { a: "184/6", b: "98/3" },
    over: "12.4",
    odds: { a: 1.78, draw: 4.2, b: 2.05 },
    status: "LIVE",
  },
  {
    id: "m2",
    league: "IPL",
    flag: "🇮🇳",
    teamA: { name: "Mumbai Indians", short: "MI", color: "#1e3a8a" },
    teamB: { name: "Chennai Super Kings", short: "CSK", color: "#fbbf24" },
    score: { a: "201/4", b: "—" },
    over: "20.0",
    odds: { a: 1.42, draw: 5.1, b: 2.85 },
    status: "LIVE",
  },
  {
    id: "m3",
    league: "BBL",
    flag: "🇦🇺",
    teamA: { name: "Sydney Sixers", short: "SYS", color: "#ec4899" },
    teamB: { name: "Perth Scorchers", short: "PER", color: "#f97316" },
    score: { a: "156/8", b: "—" },
    over: "18.2",
    odds: { a: 2.1, draw: 4.8, b: 1.72 },
    status: "LIVE",
  },
  {
    id: "m4",
    league: "PSL",
    flag: "🇵🇰",
    teamA: { name: "Karachi Kings", short: "KAR", color: "#06b6d4" },
    teamB: { name: "Lahore Qalandars", short: "LAH", color: "#84cc16" },
    score: { a: "168/5", b: "—" },
    over: "20.0",
    odds: { a: 1.95, draw: 4.5, b: 1.88 },
    status: "UP",
  },
];

// Real Baji promotional banner images (publicly available on their CDN)
export const PROMO_BANNERS = [
  "https://img.b112j.com/upload/announcement/image_299033.jpg",
  "https://img.b112j.com/upload/announcement/image_296285.jpg",
  "https://img.b112j.com/upload/announcement/image_274714.jpg",
  "https://img.b112j.com/upload/announcement/image_289801.jpg",
  "https://img.b112j.com/upload/announcement/image_289996.jpg",
  "https://img.b112j.com/upload/announcement/image_254257.jpg",
  "https://img.b112j.com/upload/announcement/image_295193.jpg",
  "https://img.b112j.com/upload/announcement/image_242206.jpg",
  "https://img.b112j.com/upload/announcement/image_241701.jpg",
];

// Sub-menu items for the side drawer
export const SIDE_SUBMENU = {
  sports: [
    { id: "cricket", label: "Cricket" },
    { id: "football", label: "Football" },
    { id: "tennis", label: "Tennis" },
    { id: "basketball", label: "Basketball" },
    { id: "esports", label: "E-Sports" },
  ],
  casino: [
    { id: "evolution", label: "Evolution" },
    { id: "pragmatic", label: "Pragmatic Play" },
    { id: "sexy", label: "Sexy" },
    { id: "playtech", label: "Playtech" },
  ],
  slots: [
    { id: "jili", label: "JILI" },
    { id: "pgsoft", label: "PG Soft" },
    { id: "pragmatic", label: "Pragmatic Play" },
    { id: "jdb", label: "JDB" },
  ],
};
